import styled from 'styled-components';

export const Container = styled.div`
  margin: 20px;
`;

export const Title = styled.button`
  font-size: 14px;
  font-family: 'Poppins', sans-serif;
  padding: 3px 0;
  margin-right: 6px;
  border-radius: 2px;
  text-align: center;
  width: 150px;
  color: white;
  background-color: #007ade;
  border: 1px solid #007ade;
`;
